'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _components = require('components');

var _classnames4 = require('classnames');

var _classnames5 = _interopRequireDefault(_classnames4);

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Asset = function (_React$Component) {
  (0, _inherits3.default)(Asset, _React$Component);

  function Asset() {
    (0, _classCallCheck3.default)(this, Asset);
    return (0, _possibleConstructorReturn3.default)(this, (Asset.__proto__ || (0, _getPrototypeOf2.default)(Asset)).apply(this, arguments));
  }

  (0, _createClass3.default)(Asset, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.asset.id !== nextProps.asset.id || this.props.asset.isFavorited !== nextProps.asset.isFavorited || this.props.asset.acl !== nextProps.asset.acl;
    }
  }, {
    key: 'onStarClick',
    value: function onStarClick(starred) {
      var _props = this.props,
          addToFavorites = _props.addToFavorites,
          removeFromFavorites = _props.removeFromFavorites,
          asset = _props.asset;

      var assetId = asset.id;

      if (starred) addToFavorites(assetId);else removeFromFavorites(assetId);
    }
  }, {
    key: 'onHighResImageLoad',
    value: function onHighResImageLoad() {
      var h = _reactDom2.default.findDOMNode(this.refs.highres);
      var l = _reactDom2.default.findDOMNode(this.refs.lowres);
      var styles = require('./Asset.scss');

      h.classList.add(styles['Asset__preview--loaded']);
      if (l !== null) l.classList.add(styles['Asset__preview--unloaded']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames, _classnames2, _classnames3;

      var _props2 = this.props,
          asset = _props2.asset,
          loggedIn = _props2.loggedIn;
      var isFavorited = asset.isFavorited;


      var isSurface = asset.categories[0] == 'surface';

      var scaleWidth = isSurface ? 1 : asset.previews.relativeSize ? parseInt(asset.previews.relativeSize.split('x')[0]) : 1;
      var scaleHeight = isSurface ? 1 : asset.previews.relativeSize ? parseInt(asset.previews.relativeSize.split('x')[1]) : 1;
      var pickWidth = scaleWidth == 2 ? 880 : scaleWidth == 4 ? 1700 : 400;
      var thumbTags = asset.categories[0] == ['3d'] ? ['highpoly', 'jpeg'] : ['thumb', 'jpeg'];
      var preview = (0, _utils.pickPreviewObj)((0, _utils.isRetina)() ? pickWidth + 'x' + pickWidth : pickWidth + 'x' + pickWidth, asset.previews.images, thumbTags);
      var src = (0, _utils.getCloudfrontUrl)(preview && preview.uri);

      var lowresSrc = (0, _utils.pickThumbUri)(asset.previews.images);

      var parsedResolution = (0, _utils.parseResolution)(preview.resolution);
      var isPreviewTall = preview && parsedResolution && parsedResolution[1] && function (height, scale) {
        return height >= [400, 880][scale - 1];
      }(parsedResolution[1], scaleHeight);

      var styles = require('./Asset.scss');

      var classes = (0, _classnames5.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.Asset, true), (0, _defineProperty3.default)(_classnames, styles['Asset--2-col'], scaleWidth == 2), (0, _defineProperty3.default)(_classnames, styles['Asset--4-col'], scaleWidth == 4), (0, _defineProperty3.default)(_classnames, styles['Asset--2-row'], scaleHeight == 2), (0, _defineProperty3.default)(_classnames, styles['Asset--2d'], asset.categories[0] == ['surface']), _classnames));

      var c = _classnames5.default;

      return _react2.default.createElement(
        'li',
        { className: classes },
        _react2.default.createElement(
          _components.PopupLink,
          { to: '/assets/' + asset.id, className: styles.Asset__wrap },
          lowresSrc && _react2.default.createElement('img', {
            className: (0, _classnames5.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, styles.Asset__preview, true), (0, _defineProperty3.default)(_classnames2, styles['Asset__preview--tall'], isPreviewTall), (0, _defineProperty3.default)(_classnames2, styles['Asset__preview--lowres'], true), _classnames2)),
            ref: 'lowres',
            src: lowresSrc,
            alt: 'Scan' }),
          _react2.default.createElement('img', {
            className: (0, _classnames5.default)((_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, styles.Asset__preview, true), (0, _defineProperty3.default)(_classnames3, styles['Asset__preview--tall'], isPreviewTall), (0, _defineProperty3.default)(_classnames3, styles['Asset__preview--highres'], true), _classnames3)),
            ref: 'highres',
            src: src,
            alt: 'Scan',
            onLoad: this.onHighResImageLoad.bind(this) })
        ),
        asset.points === 0 && _react2.default.createElement(
          'div',
          { className: styles.AssetFreeIndicator },
          _react2.default.createElement(
            'span',
            { className: styles.AssetFreeIndicator__text },
            'Free'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.AssetIndicators },
          _react2.default.createElement(
            'div',
            { className: styles.AssetIndicators__left },
            isSurface && _react2.default.createElement(
              'div',
              { className: c(styles.AssetIndicator, styles['AssetIndicator--physicalSize']) },
              _react2.default.createElement(
                'div',
                { className: styles.AssetIndicator__inner },
                _react2.default.createElement(
                  'span',
                  { className: styles.AssetIndicator__value },
                  (0, _utils.prettyPhysicalSize)(asset.physicalSize)
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.AssetIndicator__title },
                  'meters'
                )
              )
            )
          ),
          loggedIn && _react2.default.createElement(
            'div',
            { className: styles.AssetIndicators__right },
            _react2.default.createElement(
              'div',
              { className: c(styles.AssetIndicator, styles['AssetIndicator--Star'], (0, _defineProperty3.default)({}, styles['AssetIndicator--Star-favorited'], isFavorited)) },
              _react2.default.createElement(_components.Star, { starred: isFavorited, onClick: this.onStarClick.bind(this) })
            ),
            asset.acl && asset.acl.resolution && _react2.default.createElement('span', { className: c(styles.AssetIndicator, styles['AssetIndicator--Owned']) })
          )
        ),
        _react2.default.createElement('div', { className: styles['Asset__preview--overlay'] })
      );
    }
  }]);
  return Asset;
}(_react2.default.Component);

exports.default = Asset;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Asset/Asset.jsx
// module id = 2427
// module chunks = 0